export const durationInMinutes = duration => parseFloat(duration) / 60.0
export const formatDuration = duration => durationInMinutes(duration).toFixed()
export const productPerformanceMultipier = product =>
  product.side === 'unspecified' ? 1 : 2
